import React, { useState } from 'react';
import './Login.css';

interface LoginProps {
  onLogin: (username: string, password: string) => boolean;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Simulate network delay for effect
    await new Promise(resolve => setTimeout(resolve, 800));

    const success = onLogin(username, password);
    if (!success) {
      setError('ACCESS DENIED: Invalid credentials');
      setPassword('');
    }
    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-panel">
        <div className="login-header">
          <div className="terminal-bar">
            <span className="terminal-dot red" />
            <span className="terminal-dot yellow" />
            <span className="terminal-dot green" />
          </div>
          <div className="logo-section">
            <h1 className="logo-text">
              <span className="logo-accent">brainz</span>
              <span className="logo-dot">.</span>
              <span className="logo-secondary">toyo</span>
              <span className="logo-dot">.</span>
              <span className="logo-tertiary">games</span>
            </h1>
            <p className="logo-subtitle">ADMIN CONTROL PANEL</p>
          </div>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">
              <span className="label-prefix">&gt;</span> USERNAME
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username..."
              autoComplete="username"
              disabled={isLoading}
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">
              <span className="label-prefix">&gt;</span> PASSWORD
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password..."
              autoComplete="current-password"
              disabled={isLoading}
            />
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠</span>
              {error}
            </div>
          )}

          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? (
              <>
                <span className="button-spinner" />
                AUTHENTICATING...
              </>
            ) : (
              <>
                AUTHENTICATE
                <span className="button-arrow">→</span>
              </>
            )}
          </button>
        </form>

        <div className="login-footer">
          <div className="footer-line" />
          <span className="footer-text">SECURE CONNECTION</span>
          <div className="footer-line" />
        </div>
      </div>

      <div className="decorative-elements">
        <div className="hex hex-1" />
        <div className="hex hex-2" />
        <div className="hex hex-3" />
      </div>
    </div>
  );
};

export default Login;
